import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { clearAllFilters } from 'Pods/SearchPage/Store/actions'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import { getFiltersCount } from 'Pods/SearchPage/Store/selectors'

function ResetButton() {
  const activeFiltersCount = useSearchPageStore(state => getFiltersCount(state))
  const hasActiveFilters = activeFiltersCount > 0

  return (
    <Button
      type="secondary"
      customClass="filter-wrapper__button filter-wrapper__button--reset"
      onClick={hasActiveFilters ? clearAllFilters : undefined}
      aria-label="Reset filters"
      isActive={hasActiveFilters}
    >
      Reset
      <span className="filter-wrapper__reset-count">
        {hasActiveFilters ? ` (${activeFiltersCount})` : ''}
      </span>
    </Button>
  )
}

export default ResetButton
